export enum RequestType {
    Unknown = 'Unknown',
    Send = 'Send',
    Confirm = 'Confirm',
    Collect = 'Collect',
    Identity = 'Identity',
}
